import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/pages',
    component: () => import('@/views/pages/Index'),
    children: [
      {
        name: 'Login',
        path: 'login',
        component: () => import('@/views/pages/Login'),
      },
      {
        name: 'Lock',
        path: 'lock',
        component: () => import('@/views/pages/Lock'),
      },
      {
        name: 'Register',
        path: 'register',
        component: () => import('@/views/pages/Register'),
      },
    ],
  },
  {
    path: '/',
    component: () => import('@/views/dashboard/Index'),

    // meta: {
    //   requiresAuth: true,
    // },
    children: [
      {
        name: 'Dashboard',
        path: '',
        meta: {
          requiresAuth: true,
        },
        component: () => import('@/views/dashboard/Dashboard'),
      },
      {
        name: 'Recaudación',
        path: 'captura',
        meta: {
          requiresAuth: true,
        },
        component: () => import('@/views/catalogos/recaudacion'),
      },
      {
        name: 'Revisión de Recaudaciones',
        path: 'recauda',
        meta: {
          requiresAuth: true,
        },
        component: () => import('@/views/catalogos/recaudacionadmin'),
      },
      {
        name: 'Recaudaciones',
        path: 'recaudaciones',
        meta: {
          requiresAuth: true,
        },
        component: () => import('@/views/catalogos/recaudaciones'),
      },
      {
        name: 'Administración de Usuarios',
        path: 'admon/usuarios',
        meta: {
          requiresAuth: true,
        },
        //component: () => import('@/views/settings/usuarios/Usuarios'),
        component: () => import('@/views/catalogos/usuario'),
      },
      {
        name: 'Catálogo de Tipos',
        path: 'admon/tipos',
        meta: {
          requiresAuth: true,
        },
        component: () => import('@/views/catalogos/tipo'),
      },
      {
        name: 'Catálogo de Entidades',
        path: 'admon/entidades',
        meta: {
          requiresAuth: true,
        },
        component: () => import('@/views/catalogos/entidad'),
      },
      {
        name: 'Catálogo de Retenciones',
        path: 'admon/retencion',
        meta: {
          requiresAuth: true,
        },
        component: () => import('@/views/catalogos/retencion'),
      },
      {
        name: 'Catálogo de Cuentas Contables',
        path: 'admon/cuentas',
        meta: {
          requiresAuth: true,
        },
        component: () => import('@/views/catalogos/cuenta'),
      },

      {
        name: 'Perfil de Usuario',
        path: 'pages/user',
        meta: {
          requiresAuth: true,
        },
        component: () => import('@/views/dashboard/pages/UserProfile'),
      },
    ],
  },
  {
    path: '*',
    component: () => import('@/views/pages/Index'),
    children: [
      {
        name: '404 Error',
        path: '',
        component: () => import('@/views/pages/Error'),
      },
    ],
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

router.beforeEach((to, from, next) => {
  const loggedIn = localStorage.getItem('user')
  if (to.meta.requiresAuth && !loggedIn) {
    next('/pages/login')
  } else {
    next()
  }
})

export default router
